var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "复制直播间人员",
        width: "650px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "copyLiveRoomUser overflowOuto" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择直播间", prop: "liveRoomName" } },
                [
                  _c("AppSelect", {
                    attrs: {
                      "get-api-fn": _vm.getLivePage,
                      "search-key": "liveRoomName",
                      value: _vm.form.liveRoomId,
                      label: _vm.form.liveRoomName,
                      "popover-width": 300,
                      "input-width": 300,
                      props: {
                        label: "liveRoomName",
                        value: "id",
                      },
                      "label-content": _vm.lableText,
                    },
                    on: { selected: _vm.selected },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人", prop: "createUserName" } },
                [_c("span", [_vm._v(_vm._s(_vm.form.createUserName))])]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开播时间", prop: "startTime" } },
                [
                  _vm.form.startTime
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.form.startTime
                              ? _vm
                                  .moment(_vm.form.startTime)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              : ""
                          )
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "指定人数", prop: "whitePeopleNum" } },
                [
                  _vm.form.whitePeopleNum !== ""
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.form.whitePeopleNum) + "人"),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }